import * as React from 'react';
import { FormattedMessage, IntlProvider } from 'react-intl';
import styled from 'styled-components';

import { fontWeights } from '../../ui/inline-styles/variables';
import { withLocale } from '../contexts/locale.context';
import { Locale } from '../enums/locale.enum';
import { messages } from '../../../locale/messages';

interface Props {
  locale: Locale;
  dateClock: React.ReactNode;
}

const StDateLocation = styled.div``;

const StLocation = styled.span`
  padding: 0 0 0 6px;
  opacity: 0.7;
  font-size: 1.75rem;
  font-weight: ${fontWeights.thin};
  line-height: 1.43;
  color: #ffffff;
`;

class DateLocation extends React.Component<Props> {
  render() {
    const { dateClock, locale } = this.props;

    return (
      <IntlProvider locale={locale} messages={messages[locale]}>
        <StDateLocation>
          {dateClock}
          <StLocation>
            <FormattedMessage id='location' />
          </StLocation>
        </StDateLocation>
      </IntlProvider>
    );
  }
}

export default withLocale(DateLocation);



// WEBPACK FOOTER //
// ./src/app/dashboard/components/DateLocation.tsx